import { FuelAccordionContainer, FuelAccordionItem, FuelCheckbox, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import AppContext from 'context';
import React, { FC, useContext } from 'react';
import * as Styled from './styled';

const Vehicles: FC<{ checked: number[]; setChecked: (value: number[]) => void }> = ({ checked, setChecked }) => {
  const {
    state: {
      truckers: {
        meta: {
          freight: { vehicleTypes },
        },
      },
      deviceSize: { isMobile },
    },
  } = useContext(AppContext);

  const handleCheckedStatus = (id: number) => {
    if (!checked.includes(id)) {
      setChecked([...checked, id]);
    } else {
      setChecked(checked.filter((element) => element !== id));
    }
  };

  const lastCategoryItem = vehicleTypes[vehicleTypes.length - 1].category;

  return (
    <FuelAccordionContainer>
      <FuelAccordionItem
        data-testid="accordion-item-vehicles"
        key="vehicles"
        label="Veículos"
        accordionId="vehicles"
        hasDivider
      >
        {vehicleTypes.map((vehicle) => (
          <Styled.ContentAccordion
            key={vehicle.category}
            slot="content"
            hasMarginBottom={isMobile && vehicle.category === lastCategoryItem}
          >
            <FuelTypography size="body-sm" weight="bold">
              {vehicle.category}
            </FuelTypography>
            <FuelFlex
              defaultProps={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                customPadding: `0 0 0 ${dsTheme.spacing.km4}`,
              }}
            >
              {vehicle.types.map((type) => (
                <FuelCheckbox
                  key={type.id}
                  name={type.name}
                  label={type.name}
                  id={String(type.id)}
                  onInput={() => handleCheckedStatus(type.id)}
                  data-testid={`filter-vehicle-checkbox-${type.name}`}
                  checked={checked.includes(type.id)}
                />
              ))}
            </FuelFlex>
          </Styled.ContentAccordion>
        ))}
      </FuelAccordionItem>
    </FuelAccordionContainer>
  );
};

export default Vehicles;
